import { type SVGAttributes } from "react";

export function FlagIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.9729 4.90948L7.13008 20.2586"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.65471 5.90826C6.17904 6.25619 5.25127 6.89002 5.25127 6.89002L6.36465 14.8122C6.36465 14.8122 7.22284 13.6832 9.69851 13.3353C12.1742 12.9873 12.3829 14.4727 14.8586 14.1248C17.3343 13.7769 18.1854 12.6474 18.1854 12.6474L17.1416 5.22042C17.1416 5.22042 16.2905 6.34986 13.8148 6.69779C11.3391 7.04573 11.1304 5.56032 8.65471 5.90826Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
